// @ts-strict-ignore
import type { ReactNode } from "react";
import { useRef } from "react";

import { Skeleton, Spacer } from "@aviary";

import * as styles from "./EmersonAllCategories.styles";

const SkeletonCategories = () => {
  const scrollObserverRef = useRef<HTMLDivElement>(null);

  const renderSkeleton = index => (
    <Skeleton type="typography" typographySize="body" margin="top" isFullWidth key={index} />
  );

  const renderSkeletons = (numOfSkeletons: number, addObserverToIndex = -1): ReactNode[] =>
    Array.from({ length: numOfSkeletons }).map((_, i) => {
      if (addObserverToIndex === i) {
        return (
          <div key={i} ref={scrollObserverRef} css={styles.observe}>
            {renderSkeleton(i)}
          </div>
        );
      }

      return renderSkeleton(i);
    });

  return (
    <span>
      {renderSkeletons(3, 1)}
      <Spacer />
    </span>
  );
};

export { SkeletonCategories };
